import { render, staticRenderFns } from "./CreateBanner.vue?vue&type=template&id=61008cbd&scoped=true&"
import script from "./CreateBanner.vue?vue&type=script&lang=js&"
export * from "./CreateBanner.vue?vue&type=script&lang=js&"
import style0 from "./CreateBanner.vue?vue&type=style&index=0&id=61008cbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61008cbd",
  null
  
)

export default component.exports